<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='product-line-grid float-left'>
      <dx-data-grid ref='refProductLineGrid'
        :data-source='productLineInfoList'
        :show-borders='true' :showRowLines='false' :showColumnLines='true'
        :hover-state-enabled="true" :allowColumnResizing='true'
        column-resizing-mode='widget' :allow-column-reordering="true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="라인코드"
        :focused-row-key.sync='focusedRowKey'
        @row-removed='onRowRemoved' @row-removing='onRowRemoving'
        @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated'
        @editor-preparing='onEditorPreparing'
        @init-new-row='onInitNewRow'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="생산라인정보"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="(userInfo.permission & crudAllow) > 0"
          :allow-adding="(userInfo.permission & crudAllow) > 0"
          :use-icons="true"
          mode='popup'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="300"
            title="생산라인등록"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
              <DxItem
              :col-count="2"
              :col-span="2"
              item-type="group"
              >
                <DxItem data-field="라인코드"/>
                <DxItem data-field="라인명"/>
                <DxItem data-field="공정유형"/>
                <DxItem data-field="근무형태"/>
                <DxItem data-field="소속부서1"/>
                <DxItem data-field="소속부서2"/>
                <DxItem data-field="소속부서3"/>
                <DxItem data-field="비고"/>
                <DxItem data-field="생산계획"/>
                <DxItem data-field="생산로트수량"/>
                <DxItem data-field="사용유무"/>
                <DxItem data-field="삭제유무"/>

              </DxItem>
            </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          width="90"
          :buttons="editButtons"
          type="buttons"
        />
        <DxColumn
          :allowEditing='isLineCodeEdit'
          :fixed="true"
          caption="라인코드"
          data-field="라인코드"
          sort-order='asc'
        >
            <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          :fixed="true"
          caption="라인명"
          data-field="라인명"
          :visible='true'
        >
            <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="근무형태"
          data-field="근무형태"
          :visible='true'
        >
          <DxLookup
            :data-source="shiftTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="소속(반)-1"
          data-field="소속부서1"
          :visible='true'
          edit-cell-template="treeGridTemplate"
        >
          <DxLookup
            :data-source="divisionList"
            display-expr="부서명"
            value-expr="부서코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="소속(반)-2"
          data-field="소속부서2"
          :visible='true'
          edit-cell-template="treeGridTemplate"
        >
          <DxLookup
            :data-source="divisionList"
            display-expr="부서명"
            value-expr="부서코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="소속(반)-3"
          data-field="소속부서3"
          :visible='true'
          edit-cell-template="treeGridTemplate"
        >
          <DxLookup
            :data-source="divisionList"
            display-expr="부서명"
            value-expr="부서코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="비고"
          data-field="비고"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="생산계획"
          data-field="생산계획"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="생산로트수량"
          data-field="생산로트수량"
          dataType="number"
          :visible='true'
        >
          <dx-required-rule message="생산로트수량을 입력 하세요."/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="삭제유무"
          data-field="삭제유무"
          :visible='true'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="라인코드"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <template #treeGridTemplate="{ data: cellInfo }">
          <DivisionTreeGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            :data-source="divisionList"
          />
        </template>
      </dx-data-grid>
    </div>
    <!-- ******************* 라인별 등록설비 ********************** -->
    <div class='line-machine-grid float-left'>
      <dx-data-grid ref='refLineMachineGrid'
        :data-source='lineMachineInfoList'
        :show-borders='true' :showRowLines='false' :showColumnLines='true'
        :hover-state-enabled="true" :allowColumnResizing='true'
        column-resizing-mode='widget' :allow-column-reordering="true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="설비코드"
        @row-removed='onRowRemovedMachine'
        @toolbar-preparing='onToolbarPreparingMachine'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="생산라인정보"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="(userInfo.permission & crudAllow) > 0"
          :allow-updating="false"
          :allow-adding="false"
          :use-icons="true"
          mode='row'
        >
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='isIdEdit'
          :fixed="true"
          caption="설비코드"
          data-field="설비코드"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          :fixed="true"
          caption="설비명"
          data-field="설비명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="설비유형"
          data-field="설비유형"
          :visible='true'
        >
          <DxLookup
            :data-source="machineTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="규격"
          data-field="규격"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="제조사"
          data-field="제조사"
          :visible='true'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="설비코드"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <template #line-machine-title>
          <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
            <b v-if='selectedLineInfo'>{{selectedLineInfo.라인명}}</b>
          </div>
      </template>
      </dx-data-grid>
    </div>
    <!-- ****************** 설비 리스트 *************************** -->
    <div class='machine-grid float-left'  style='overflow:hidden;display:block; width:0%; margin-left:10px;'>
      <dx-data-grid ref='refMachineGrid'
        :data-source='machineInfoList'
        :show-borders='true' :showRowLines='false' :showColumnLines='true'
        :hover-state-enabled="true" :allowColumnResizing='true'
        column-resizing-mode='widget' :allow-column-reordering="true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        :selected-row-keys.sync="selectedRowKeysMachine"
        key-expr="설비코드"
        @toolbar-preparing='onToolbarPreparingMachineList'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxSelection mode="multiple"
          show-check-boxes-mode="always"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumn
          :allowEditing='isIdEdit'
          :fixed="true"
          caption="설비코드"
          data-field="설비코드"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="설비명"
          data-field="설비명"
          :visible='true'
          :fixed="true"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="설비유형"
          data-field="설비유형"
          :visible='true'
        >
          <DxLookup
            :data-source="machineTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="규격"
          data-field="규격"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="제조사"
          data-field="제조사"
          :visible='true'
        >
        </DxColumn>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm, DxSelection,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import DivisionTreeGridComponent from '../../share/component/DivisionTreeGridComponent'

export default {
  name: 'product-line',
  data: function () {
    return {
      crudAllow: ConstDef.CRUD_ALLOW_생산_연구,
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      productLineInfoList: [],
      focusedRowKey: null,
      divisionList: null,
      processingTypeLookup: null,
      isIdEdit: false,
      isLineCodeEdit: true,
      editButtons: [ 'edit',
        {
          hint: '라인삭제',
          icon: 'trash',
          visible: 'true',
          onClick: this.onClickDeleteLine
        }],
      selectedLineInfo: null,
      shiftTypeLookup: ConstDef.근무형태,
      //* ******* 설비정보 *******************/
      lineMachineInfoList: null,
      selectedMachineCode: null,
      machineTypeLookup: null,
      lineName: null,
      // *********** 설비 리스트 *******************
      machineInfoList: null,
      selectedRowKeysMachine: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxForm,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxPopup,
    DxPosition,
    DxRequiredRule,
    DxItem,
    DxSelection,
    DivisionTreeGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.machineTypeLookup = this.$_.sortBy(this.$store.getters.getBaseDataByType(ConstDef.설비유형), '설명')
    this.refreshDivision()
    this.refresProductLine()
    this.refreshMachineList()
    console.log(ConstDef.근무형태)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onClickDeleteLine (e) {
      console.log(e)
      this.$snotify.confirm('해당 라인의 등록 설비도 삭제 됩니다.', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '삭제',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.onRowRemoved(e.row)
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    onEditorPreparing (e) {
      if (e.dataField === '라인코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isLineCodeEdit = true
        } else {
          this.isLineCodeEdit = false
        }
      }
    },
    onInitNewRow (row) {
      row.data.사용유무 = true
      row.data.삭제유무 = false
      // row.data.라인코드='자동설정'
    },
    onRowInserted (row) {
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userName
      this.$_sp.runInsertSqlProc('생산라인', null, [row.data])
        .then((data) => {
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserting (row) {
      const index = this.$_.findIndex(this.productLineInfoList, { 라인코드: row.data.라인코드 })
      if (index >= 0) {
        this.$snotify.info('라인코드가 중복 되었습니다.')
        row.cancel = true
      }
    },
    onRowRemoved (row) {
      console.log(this.selectedLineInfo)
      this.$_sp.runUpdateProc('spDeleteLineWithMachineByLineCode', [{ 라인코드: row.data.라인코드 }])
        .then((data) => {
          this.productLineInfoList = this.$_.without(this.productLineInfoList, row.data)
          this.lineMachineInfoList = null
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoving (row) {
    },
    onRowUpdated (row) {
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('생산라인', ['라인코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedLineInfo = e.row.data
        this.lineName = this.selectedLineInfo.라인명
      }
      this.selectedRowKeysMachine = null
      this.refreshLineMachine(this.selectedLineInfo.라인코드)
    },
    refreshDivision () {
      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    refresProductLine () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.productLineInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    // ************** 설비정보 *********************
    // ************** 설비정보 *********************
    // ************** 설비정보 *********************
    addMachineList () {
      this.$Q('.product-line-grid').css('width', '20%')
      this.$Q('.line-machine-grid').css('width', '39%')
      this.$Q('.machine-grid').css('width', '38%')
    },
    onRowRemovedMachine (row) {
      this.$_sp.runDeleteSqlProc('생산라인설비', [{ 라인코드: row.data.라인코드, 설비코드: row.data.설비코드 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onToolbarPreparingMachine (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'line-machine-title'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '설비 추가',
            icon: 'add',
            text: '설비추가',
            type: 'default',
            disabled: (this.userInfo.permission & this.crudAllow) === 0,
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.selectedLineInfo === null) {
                this.$snotify.info('선택된 생산 라인 정보가 앖습니다.')
                return
              }
              this.addMachineList()
            }
          }
        }
      )
    },
    refreshLineMachine (lineCode) {
      this.$_sp.runNoEncodeFindProc('spFindAllMachineByLineCode', { 라인코드: lineCode })
        .then((data) => {
          this.lineMachineInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    setMachineCode (mCode) {
      this.selectedMachineCode = mCode
    },
    // ************** 설비 리스트 정보 *********************
    // ************** 설비 리스트 정보 *********************
    // ************** 설비 리스트 정보 *********************

    onToolbarPreparingMachineList (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            type: 'success',
            hint: '추가',
            icon: 'add',
            text: '선택설비 추가',
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.selectedRowKeysMachine.length === 0) {
                this.$snotify.info('선택된 설비가 없습니다.')
                return
              }
              let saveList = []
              console.log(this.selectedRowKeysMachine)
              for (let i = 0; i < this.selectedRowKeysMachine.length; i++) {
                if (this.$_.findIndex(this.lineMachineInfoList, { 설비코드: this.selectedRowKeysMachine[i] }) >= 0) {
                  continue
                }
                let temp = {
                  라인코드: this.selectedLineInfo.라인코드,
                  설비코드: this.selectedRowKeysMachine[i],
                  createid: this.userInfo.userName,
                  updateid: this.userInfo.userName
                }
                saveList.push(temp)
              }
              this.saveMachinelist(saveList)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'close',
            text: '닫기',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('.product-line-grid').css('width', '49%')
              this.$Q('.line-machine-grid').css('width', '49%')
              this.$Q('.machine-grid').css('width', '0%')
            }
          }
        }

      )
    },
    refreshMachineList () {
      this.$_sp.runNoEncodeFindSqlProc('설비정보', null)
        .then((data) => {
          this.machineInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    saveMachinelist (list) {
      this.isLoading = true
      this.$_sp.runInsertSqlProc('생산라인설비', null, list)
        .then((data) => {
          this.isLoading = false
          this.$snotify.info(`${list.length}행 등록 하였습니다.`)
          this.refreshLineMachine(this.selectedLineInfo.라인코드)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.product-line-grid {
  width: 49%;
  margin-right:2%
}
.line-machine-grid {
  width: 49%;
}
</style>
